import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	workItemLabel: {
		id: 'relay.jira-dc-work-item.work-item.work-item-label',
		defaultMessage: 'Work item',
		description: 'Work item label',
	},
	issueLabel: {
		id: 'relay.jira-dc-work-item.issue-label',
		defaultMessage: 'Issue',
		description: 'Issue label',
	},
});
